<template>
  <section class="viewsrhwx_wxChatLogin"></section>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "viewsrhwx_wxChatLogin",

  props: [""],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  components: {},

  mixins: [],

  beforeCreate() {},

  created() {
    document.title = this.$route.query.title || "";
    this.$common
      .http({
        url: "/api/pcenter/detail"
      })
      .then(res => {
        this.fetchPrivilege();
        console.log(res);
        let path = localStorage.getItem("rhwxWxChatLoginRedirectPath");
        let query = localStorage.getItem("rhwxWxChatLoginRedirectQuery") || {};
        query = JSON.parse(query);
        this.$router.replace({
          path,
          query
        });
        localStorage.removeItem("rhwxWxChatLoginRedirectPath");
        localStorage.removeItem("rhwxWxChatLoginRedirectQuery");
      });
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    ...mapActions(["fetchPrivilege"])
  }
};
</script>
<style lang="less" scoped>
.viewsrhwx_wxChatLogin {
}
</style>
<style lang="less">
.viewsrhwx_wxChatLogin {
}
</style>
